// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Np8L","col":"Table_col__1F6IF","fulfillmentStatus":"Table_fulfillmentStatus__qjRKi","emailCol":"Table_emailCol__3SBWm"};